import { CartAddEvent } from '@theme/events';

class SanniCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-sanni-upsell-add]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
    this.#addItem(button);
  };

  async #addItem(button) {
    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;
    const label = button.querySelector('[data-sanni-upsell-label]');
    const status = this.querySelector('[data-sanni-upsell-status]');

    if (!variantId || button.disabled) return;

    button.disabled = true;
    if (label) label.textContent = 'Se adaugă…';

    try {
      const sectionIds = [...new Set(
        [...document.querySelectorAll('cart-items-component')]
          .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
          .filter(Boolean)
      )];

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Produsul nu a putut fi adăugat.');
      }

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      const disclosure = this.querySelector('[data-sanni-upsell-details]');

      if (disclosure instanceof HTMLDetailsElement) disclosure.open = false;
      if (status) status.textContent = 'Produs adăugat în coș.';

      this.dispatchEvent(new CartAddEvent(cart, `sanni-cart-upsell-${variantId}`, {
        source: 'sanni-cart-upsell',
        itemCount: 1,
        productId,
        variantId,
        sections: result.sections,
      }));
    } catch (error) {
      console.error('Sanni cart upsell:', error);
      button.disabled = false;
      if (label) label.textContent = 'Încearcă din nou';
      if (status) status.textContent = error instanceof Error ? error.message : 'Produsul nu a putut fi adăugat.';
      window.setTimeout(() => {
        if (label) label.textContent = 'Adaugă';
      }, 2500);
    }
  }
}

if (!customElements.get('sanni-cart-upsell')) {
  customElements.define('sanni-cart-upsell', SanniCartUpsell);
}
